<template>
    <div class='drop'>
        <v-layout justify-center align-content-center align-center column>
        <v-icon color="#ED722F" size='75' style='padding-right:10px'>mdi-alert-decagram</v-icon>
        <h2 style="color:#00558C">Page Not Found</h2>
        <v-card-subtitle>The page you requested has moved or does not exist.</v-card-subtitle>
        <v-card-subtitle>Please click <a @click="$router.push('/')">here</a> to be redirected.</v-card-subtitle>

        </v-layout>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.drop{
    margin-top: 150px;

}

</style>